import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, AppBar, Box, Button, Menu, MenuItem, Toolbar } from '@mui/material';
import SupportMenu from './SupportMenu';
import { SiteSection } from '../../../shared/types';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExternalLinks from '../../../shared/externalLinks';
import Styles from './css/DesktopHeaderStyles';


const DesktopHeader = () => {
    const [openMenu, setOpenMenu] = React.useState<SiteSection | null>(null);
    const { Hospitality, SeniorLiving, Support, Pricing } = SiteSection;
    const [getStartedAnchor, setGetStartedAnchor] = React.useState<Element | null>(null);

    const handleGetStartedClick = (event: React.MouseEvent<HTMLElement>) => {
        setGetStartedAnchor(event.currentTarget);
    };

    const handleGetStartedClose = () => {
        setGetStartedAnchor(null);
    };

    return (
        <Box onMouseLeave={() => setOpenMenu(null)}>
            <AppBar sx={Styles.AppBar}>
                <Toolbar variant='dense'>
                    <Box sx={Styles.ToolbarContentContainer}>
                        <img style={Styles.Logo as React.CSSProperties} alt="Aipex Logo (gray)" src={ExternalLinks.AIPEX_LOGO} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOME; }} />
                        <Box sx={Styles.ToolbarCategoryMenuContainer}>
                            <Button id="hospitality-btn" sx={Styles.CategoryMenuButton} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOSPITALITY.HOME; }}>{Hospitality}</Button>
                            <Button id="pricing-btn" sx={Styles.CategoryMenuButton} onMouseOver={() => setOpenMenu(null)} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOSPITALITY.PRICING }}>{Pricing}</Button>
                            <Button id="support-btn" sx={Styles.SupportButton} onMouseOver={() => setOpenMenu(Support)} endIcon={<ExpandMore />}>{Support}</Button>
                            <Button id="senior-living-btn" sx={Styles.SeniorLivingButton} onMouseOver={() => setOpenMenu(null)} onClick={() => { window.location.href = ExternalLinks.MARKETING.SENIOR_LIVING.HOME; }}>{SeniorLiving}</Button>
                        </Box>
                        <Box sx={Styles.DropdownMenuContainer}>
                            <Button variant="contained" sx={Styles.LogInButton} onClick={() => { window.location.href = ExternalLinks.VCS_PORTAL.HOME}}>Log In</Button>
                            <Button variant="contained" color="secondary" sx={Styles.GetStartedButton} onClick={handleGetStartedClick} endIcon={<ExpandMore />}>Get Started</Button>
                            <Menu
                                anchorEl={getStartedAnchor}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                open={Boolean(getStartedAnchor)}
                                onClose={handleGetStartedClose}
                                MenuListProps={{
                                    sx: {
                                        py: 0
                                    }
                                }}
                            >
                                <MenuItem sx={Styles.GetStartedMenuItem} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOSPITALITY.GET_STARTED; }}>Hospitality</MenuItem>
                                <MenuItem sx={Styles.GetStartedMenuItem} onClick={() => { window.location.href = ExternalLinks.MARKETING.SENIOR_LIVING.CONTACT; }}>Senior Living</MenuItem>
                            </Menu>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
            <Accordion sx={Styles.Accordion} expanded={openMenu != null}>
            <AccordionSummary sx={Styles.AccordionSummary}></AccordionSummary>
                    <AccordionDetails sx={Styles.AccordionMenu}>
                        <SupportMenu />
                    </AccordionDetails>
            </Accordion>
        </Box>

    );
}

export default DesktopHeader;